

export const getChart1 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};
export const getChart2 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};
export const getChart3 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};
export const getChart4 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};
export const getChart5 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};
export const getChart6 = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 6 }, (_, i) => ({
        name: `M${i + 1}`,
        value: Math.floor(Math.random() * 100)
      }));

      resolve(data);
    }, 300);
  });
};


/*
export const getChart2 = () =>
  fetch("/api/chart2").then(res => res.json());

export const getChart3 = () =>
  fetch("/api/chart3").then(res => res.json());

export const getChart4 = () =>
  fetch("/api/chart4").then(res => res.json());

export const getChart5 = () =>
  fetch("/api/chart5").then(res => res.json());

export const getChart6 = () =>
  fetch("/api/chart6").then(res => res.json());
*/